"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _utils = require("../../../../../configuration/utils");

var _creators = require("../../../../../redux/creators");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ResetFiltersComponent = function ResetFiltersComponent(_ref) {
  var type = _ref.type;
  var dispatch = (0, _reactRedux.useDispatch)();
  var selectedFilters = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedFilters;
  });
  var pepFilters = (0, _reactRedux.useSelector)(function (state) {
    return state.pepFilters;
  });
  var pimApi = (0, _reactRedux.useSelector)(function (state) {
    return state.productList;
  });
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });

  var resetFilters = function resetFilters(e) {
    e.preventDefault();
    Object.keys(pepFilters).forEach(function (key) {
      pimApi.resetFilter(pepFilters[key].property);
    });
    var filteredProducts = pimApi.filteredProducts();
    dispatch((0, _creators.setActiveProducts)(filteredProducts));
    dispatch((0, _creators.setSelectedFilters)((0, _utils.createActiveFilters)(pimApi.getFilters())));
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, selectedFilters.length > 0 && type === 'link' && /*#__PURE__*/_react["default"].createElement("a", {
    href: "#",
    onClick: resetFilters,
    className: "clear-filters-button"
  }, dictionary.clear), type === 'button' && /*#__PURE__*/_react["default"].createElement("a", {
    href: "#",
    className: "pep-button bg-white",
    onClick: resetFilters
  }, dictionary.reset));
};

var _default = ResetFiltersComponent;
exports["default"] = _default;